import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    minWidth: 240,
    height: 64,
    borderRadius: 16,
    border: '1px solid #C4C6C9',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 24,
    paddingRight: 8,
    overflow: 'hidden',
    '& + &': {
      marginTop: 16,
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 120,
      width: 120,
      flexDirection: 'column',
      padding: 8,
      '& + &': {
        marginTop: 0,
        marginLeft: 8,
      },
    },
  },
  active: {
    backgroundColor: 'rgba(112, 48, 160, 0.1)',
    boxShadow: '0px 8px 8px rgba(0, 0, 0, 0.15)',
  },
  title: {
    width: '100%',
    fontWeight: 'bold',
    fontSize: '1.125rem',
    textTransform: 'uppercase',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
      textAlign: 'center',
    },
  },
  value: {
    width: '80%',
    fontWeight: 'bold',
    fontSize: '2rem',
    textTransform: 'uppercase',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: '1.125rem',
      textAlign: 'center',
    },
  },
}));
